import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../environments/environment';
import { CountryDataService } from '../services/country.service';
import { AppDetailsService } from '../services/app-details.services';
import { Utility } from '../shared/utility/utility';
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LandingPageComponent implements OnInit {

  logoName;
  isCountryAllowed = 0;
  siteUrlPath: string = environment.siteUrl;
  websiteName = environment.website_name;
  websiteLogoExtension = environment.website_logo_extension;
  constructor(
    private countryDataService: CountryDataService,
    private appDetails: AppDetailsService,
    private utils : Utility
  ) { }

  ngOnInit() {
    this.getCountry();
    this.utils.gtmEvent("currentViewingPage", {
      currentPage: "landing"
    });
  }

  getCountry(country?: String) {
    if (environment.trustlyCountries.indexOf(this.countryDataService.ipCountry.toUpperCase()) >= 0) {
      this.isCountryAllowed = 1;
      this.appDetails.country = this.countryDataService.ipCountry;
    } else {
      this.isCountryAllowed = 2;
      this.appDetails.country = null;
    }
  }
}
